import "core-js/modules/es.promise.js";
import { defineStore } from 'pinia';
import { GAME_PCODE_CONFIG } from '@/hooks/useGameConfig';
export const useCommonStatus = defineStore('commonStatus', {
  state: function () {
    return {
      showHelp: false,
      orderRecordVisible: false,
      orderDetailVisible: false,
      usdkOrder: '',
      payData: {},
      authVisible: false,
      feedbackVisible: false,
      // 是否是摸鱼社app
      isMoyuApp: navigator.userAgent.includes('Hero'),
      // isMoyuApp: true,
      isWeixin: navigator.userAgent.toLowerCase().includes('micromessenger'),
      noReminderTodayActivity: '',
      // 支付loading
      payLoadingVisible: false,
      // 支付成功弹窗
      paySuccessVisible: false,
      // 活动中心弹窗
      activityCenterVisible: false,
      // 代金券活动弹窗
      voucherActivityVisible: false,
      // 赠送活动弹窗
      limitRebateVisible: false,
      // 免费礼包领取成功弹窗
      freeGiftSuccessVisible: false,
      // 微信支付弹窗
      wechatPayVisible: false,
      // 未登录的提示语
      unLoginTips: '',
      // 微信内点击授权登录，弹出提示
      guideVisible: false
    };
  },
  actions: {
    setPaySuccessVisible(paySuccess) {
      this.paySuccessVisible = paySuccess;
    },
    setPayLoadingVisible(Visible) {
      this.payLoadingVisible = Visible;
    },
    setUsdkOrder(usdkOrder) {
      console.log('usdkOrder', usdkOrder);
      this.usdkOrder = usdkOrder || '';
    },
    setActivityCenterVisible(Visible) {
      this.activityCenterVisible = Visible;
    },
    setVoucherActivityVisible(Visible) {
      this.voucherActivityVisible = Visible;
    },
    setLimitRebateVisible(Visible) {
      this.limitRebateVisible = Visible;
    },
    setFreeGiftSuccessVisible(Visible) {
      this.freeGiftSuccessVisible = Visible;
    },
    setGuideVisible(Visible) {
      this.guideVisible = Visible;
    },
    setWechatPayVisible(Visible) {
      this.wechatPayVisible = Visible;
    },
    setPayData(data) {
      this.payData = data;
    },
    async loadMoyuJsSdk(path, cb) {
      const s = document.createElement('script');
      s.src = '//herobox-cdn.yingxiong.com/h5/js/moyu-js-sdk.js';
      s.onload = function () {
        window.moyuJSSDK.init({
          dev: process.env.BASE_ENV !== 'cn_mall',
          // dev: true,
          pcode: GAME_PCODE_CONFIG[path] || 0,
          success: function (res) {
            // res.token = 'de80df53-51b9-407c-ae59-577360d3b5e3'
            // const localAccessToken = localStorage.getItem('accessToken')
            // localStorage.setItem('accessToken', (res.token as string) || '')
            const localTokens = JSON.parse(localStorage.getItem('mysTokens') || '{}');
            // 先取出当前游戏的本地token
            const localAccessToken = localTokens[window.globalRoute.path];
            localTokens[window.globalRoute.path] = res.token || '';
            localStorage.setItem('mysTokens', JSON.stringify(localTokens));
            // 获取的token和本地存储的token不相等，说明是切换账号了，清除本地账号缓存
            if (localAccessToken !== res.token) {
              localStorage.removeItem('gameRoleInfo');
            }
            cb && cb();
          }
        });
      };
      document.head.appendChild(s);
    },
    setShowHelp(showHelp) {
      this.showHelp = showHelp;
    },
    setOrderRecordVisible(orderRecordVisible) {
      this.orderRecordVisible = orderRecordVisible;
    },
    setAuthVisible(authVisible) {
      this.authVisible = authVisible;
    },
    setFeedbackVisible(visible) {
      this.feedbackVisible = visible;
    },
    setNoReminderActivity(val) {
      this.noReminderTodayActivity = val;
    },
    getOrigin(isMobile) {
      let source = 1;
      if (isMobile) {
        source = 2;
      }
      if (this.isMoyuApp) {
        source = 3;
      }
      if (this.isWeixin) {
        source = 4;
      }
      return source;
    }
  },
  persist: {
    key: '__hero_mall_common__',
    storage: localStorage,
    paths: ['noReminderTodayActivity', 'payLoadingVisible', 'usdkOrder', 'payData']
  }
});